/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';

import {
  ErrorBoundary,
  SearchBox,
  SearchProvider,
  WithSearch
} from '@elastic/react-search-ui';
import { navigate } from 'gatsby';
import '@elastic/react-search-ui-views/lib/styles/styles.css';
import { config } from './config';
import Layout from './Layout';
import { StyledWrapper } from './styles';

const SearchUiSuggestions = (): JSX.Element => {
  return (
    <StyledWrapper>
      <SearchProvider config={config} role="form">
        <WithSearch
          mapContextToProps={({
            wasSearched,
            setSearchTerm,
          }: any) => ({
            wasSearched,
            setSearchTerm,
          })}
        >
          {({
            setSearchTerm,
          }: any) => {
            return (
              <div className="App">
                <ErrorBoundary>
                  <Layout
                    header={
                      <SearchBox
                        onSubmit={searchTerm => {
                          navigate(`${process.env.GATSBY_SHOP_URL}?q=` + encodeURIComponent(searchTerm));
                          setSearchTerm(searchTerm);
                        }}
                        inputView={({
                          getAutocomplete,
                          getInputProps,
                          getButtonProps,
                        }) => (
                          <>
                            <div className="sui-search-box__wrapper">
                              <input
                                {...getInputProps({
                                  className: 'input__search',
                                  placeholder: 'Search our stores',
                                  'aria-labelledby': 'Search our stores',
                                })}
                                role="form"
                              />
                              {getAutocomplete()}
                            </div>
                            <input
                              {...getButtonProps({
                                className: 'btn__btn-primary sr',
                              })}
                            />
                          </>
                        )}
                        autocompleteMinimumCharacters={3}
                        autocompleteResults={{
                          sectionTitle: 'Popular Stores',
                          titleField: 'name',
                          urlField: 'website',
                        }}
                        autocompleteSuggestions={{
                          sectionTitle: 'Popular Search Terms',
                        }}
                        onSelectAutocomplete={(selection, { }, defaultOnSelectAutocomplete) => {
                          if (selection.suggestion) {
                            navigate(`${process.env.GATSBY_SHOP_URL}?q=` + encodeURIComponent(selection.suggestion));
                          } else {
                            defaultOnSelectAutocomplete(selection);
                          }
                        }}
                      />
                    }
                  />
                </ErrorBoundary>
              </div>
            );
          }}
        </WithSearch>
      </SearchProvider>
    </StyledWrapper>
  );
};

export default SearchUiSuggestions;
